import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagedResponseModel } from '@models/Generic/paged-response.model';
import { IFlaggedContent } from '@modules/admin/_models/flagged-content.model';
import { ResponseModel } from '@modules/auth/_models/response.model';
import { map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root'
})
export class ReportContentService {

  constructor(
    private http: HttpClient,
  ) {}

  public sendReport(
    flagType: string, 
    note: string,
    postId: number, 
    replyId?: number,
  ): Observable<boolean> {
    const body = {
      postId,
      flagType,
      note,
    }
    if (replyId) body['replyId'] = replyId;

    return this.http.post<ResponseModel<boolean>>(`${API_USERS_URL}/v1/ContentFlag`, { ...body }).pipe(
      map((response) => response.data)
    );
  }

  public getReportedContent(pageNumber: number): Observable<IFlaggedContent[]> {
    return this.http.get<PagedResponseModel<IFlaggedContent>>(`${API_USERS_URL}/v1/ContentFlag`, {
      params: {
        pageNumber,
        pageSize: 10,
      }
    }).pipe(
      map((response: PagedResponseModel<IFlaggedContent>) => response.data)
    );
  }

  public dismissReport(contentId: number): Observable<IFlaggedContent> {
    return this.http.put<ResponseModel<IFlaggedContent>>(`${API_USERS_URL}/v1/ContentFlag/${contentId}/dismiss`, {}).pipe(
      map((response) => response.data)
    );
  }

  public deactivateUser(contentId: number): Observable<IFlaggedContent> {
    return this.http.put<ResponseModel<IFlaggedContent>>(`${API_USERS_URL}/v1/ContentFlag/${contentId}/deactivate-user`, {}).pipe(
      map((response) => response.data)
    );
  }

  public deleteContent(contentId: number): Observable<IFlaggedContent> {
    return this.http.put<ResponseModel<IFlaggedContent>>(`${API_USERS_URL}/v1/ContentFlag/${contentId}/delete-content`, {}).pipe(
      map((response) => response.data)
    );
  }
}
